import React from "react";
import NumberFormat from "react-number-format";
import { Typography } from "@mui/material";
import { API_URL } from "../../utils/axios";
import "./style.scss";
import { icons } from "../../constants";
import InvestorInfo from "../InvestorInfo";
import moment from "moment";

const getRoundedValue = (val, digit) => {
  const value = parseFloat(val);
  return Math.round(value * Math.pow(10, digit)) / Math.pow(10, digit);
};

const title = {
  invest: "Total Investment Assets",
  save: "Total Saving Assets",
  retirement: "Total Retirement Assets",
};

const OverviewCard = ({
  totalAsset,
  totalReturn,
  lastUpdate,
  type,
  projectedReturn = "3.70%",
  riskLevel,
  riskIndex,
  handleShowInvestorPopup,
  saveInceptionDate,
}) => {
  return (
    <>
      <div className={`c-card-overview c-card-overview--${type}`}>
        <p>{title[type]}</p>

        <div className="c-card-overview__total-assets">
          <span>{totalAsset < 0 && "-"}RM </span>
          <NumberFormat
            value={
              totalAsset > 0
                ? getRoundedValue(totalAsset, 2)
                : getRoundedValue(totalAsset, 2) * -1
            }
            thousandSeparator
            displayType="text"
            decimalScale={2}
            fixedDecimalScale={true}
          />
        </div>
        {type !== "retirement" && (
          <Typography
            style={{
              fontFamily: "FSElliotPro",
              fontSize: "16px",
              fontWeight: "normal",
              lineHeight: 1.5,
              color: "#ddf75b",
              margin: "0.5rem 0",
            }}
          >
            Total returns:{" "}
            <span style={{ fontWeight: 700 }}>
              {totalReturn < 0 ? "-" : "+"}RM{" "}
              <NumberFormat
                value={
                  totalReturn > 0
                    ? getRoundedValue(totalReturn, 2)
                    : getRoundedValue(totalReturn, 2) * -1
                }
                thousandSeparator
                displayType="text"
                decimalScale={2}
                fixedDecimalScale={true}
              />
            </span>
          </Typography>
        )}

        <Typography
          style={{
            fontFamily: "FSElliotPro",
            fontWeight: "normal",
            fontSize: "14px",
            lineHeight: "22px",
            opacity: 0.7,
            color: "#fff",
            width: "100%",
            textAlign: "center",
          }}
        >
          {lastUpdate !== "Invalid date" && `Last update: ${lastUpdate}`}
          <br />
          {API_URL.mp === "https://mpsit.principal.com.my/api/v1"
            ? "SIT (for debugging)"
            : ""}
        </Typography>
      </div>

      {type === "save" && (
        <div className="c-card-overview--extended">
          <div>
            <div>
              <span
                style={{
                  color: "#1793D7",
                  fontWeight: 900,
                  fontSize: "1.2rem",
                }}
              >
                {`${projectedReturn} p.a`}
              </span>
              {/* <span
                style={{
                  color: "#29B9D5",
                  position: "relative",
                  bottom: "0.5rem",
                  marginLeft: "0.3rem",
                  fontSize: "0.8rem",
                  fontWeight: 700,
                }}
              >
                new{" "}
                <svg
                  width="18"
                  height="16"
                  viewBox="0 0 18 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M16.3327 4L9.99935 10.3333L6.66602 7L1.66602 12"
                    stroke="#29B9D5"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M12.334 4H16.334V8"
                    stroke="#29B9D5"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span> */}
            </div>
            <span
              style={{
                color: "#333333",
                fontSize: "0.813rem",
                display: "inline-block",
                marginTop: "0.5rem",
              }}
            >
              As of {moment(saveInceptionDate).format("D MMM YYYY")}
            </span>
          </div>
          <div
            style={{
              color: "#1278CC",
              display: "flex",
              alignItems: "center",
              cursor: "pointer",
            }}
            onClick={() => {
              window.my.navigateTo({
                url:
                  "/pages/link/link?url=" +
                  encodeURIComponent(
                    process.env.REACT_APP_ENV.trim() === "production"
                      ? "https://www.principal.com.my/en/immfd/mv"
                      : "https://www.test.principal.com.my/en/immfd/mv"
                  ),
              });
            }}
          >
            <img
              src={icons.infoPrimary}
              alt="info primary"
              style={{ width: "1.2rem", height: "1.2rem" }}
            />
            <span style={{ fontSize: "0.813rem", marginLeft: "0.4rem" }}>
              Fund info
            </span>
          </div>
        </div>
      )}

      {type === "invest" && (
        <InvestorInfo
          handleClick={handleShowInvestorPopup}
          riskIndex={riskIndex}
          riskLevel={riskLevel}
        />
      )}
    </>
  );
};

export default OverviewCard;
